import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import { ROUTES } from '../../AppRouting';
import { TeamQDateAndTeamSelectors } from '../../pages/TeamQ/components/dateAndTeamSelector/DateAndTeamSelectors';
import { getChartsData } from '../../store/charts/charts.actions';
import { RootState } from '../../store/store';
import { Avatar } from '../Avatar/Avatar';
import CustomSelect from '../CustomSelect/CustomSelect';
import { getCurrentPath } from '../utils';

export const Header: React.FC = (): JSX.Element => {
  const { user } = useSelector((state: RootState) => state.auth);

  const {
    uhPossessionsStatus,
    estTendenciesStatus,
    qActivityStatus,
    sentimentStatus,
    responseTimeStatus,
    participansStatus,
    emailLengthStatus,
    topDomainsStatus,
    sellingZoneStatus,
    mostCompetentStatus,
    leastCompetentStatus,
  } = useSelector((state: RootState) => state.charts);

  const { pathname } = useLocation();

  // eslint-disable-next-line
  const [dateArray, setDateArray] = useState<any>();

  const [open, setOpen] = useState(false);

  const history = useHistory();

  const dispatch = useDispatch();

  const avatar = useRef<HTMLDivElement>(null);

  const generateDateArray = () => {
    const today = moment().format('YYYY-MM-DD');
    const ninetyDays = moment().subtract(90, 'days').format('YYYY-MM-DD');
    const thirtyDays = moment().subtract(30, 'days').format('YYYY-MM-DD');
    const sevenDays = moment().subtract(7, 'days').format('YYYY-MM-DD');
    const arr = [
      { label: 'Last 7 days', from: sevenDays, to: today },
      { label: 'Last 30 days', from: thirtyDays, to: today },
      { label: 'Last 90 days', from: ninetyDays, to: today },
    ];

    return arr;
  };

  useEffect(() => {
    setDateArray(generateDateArray());
  }, []);

  const currentRoute = ROUTES.find(
    ({ path }) => getCurrentPath(path, user) === pathname
  );

  const loadDataByChoosedPeriod = (arr: typeof dateArray) => {
    const fromDate = arr.from;
    const toDate = arr.to;

    if (user) {
      dispatch(getChartsData(user.orgId, user.userId, fromDate, toDate));
    }
  };

  const handleClickOutside = (e: MouseEvent) => {
    const target = e.target as Node;
    const isAvatarTarget = avatar.current?.contains(target);
    if (!isAvatarTarget && open) setOpen(false);
    else if (isAvatarTarget) setOpen(!open);
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () =>
      document.removeEventListener('click', handleClickOutside, true);
  });

  const headerTitle = () => {
    let title: string | JSX.Element = currentRoute?.label || '';

    if (currentRoute?.label === 'Account') {
      title = 'Admin Settings';
    } else if (currentRoute?.label === 'Personal Q') {
      title = 'Your Personal Q';
    } else if (currentRoute?.label === 'My Engagements') {
      title = '';
    } else if (pathname.includes('team-analytics/overview')) {
      title = 'Overview';
    } else if (pathname.includes('team-analytics/activity')) {
      title = 'Team Activity';
    } else if (pathname.includes('team-analytics/analytics')) {
      title = 'Team Analytics';
    }

    return title;
  };

  const isLoadingCheck =
    uhPossessionsStatus.isLoading ||
    estTendenciesStatus.isLoading ||
    qActivityStatus.isLoading ||
    sentimentStatus.isLoading ||
    responseTimeStatus.isLoading ||
    participansStatus.isLoading ||
    emailLengthStatus.isLoading ||
    topDomainsStatus.isLoading ||
    sellingZoneStatus.isLoading ||
    mostCompetentStatus.isLoading ||
    leastCompetentStatus.isLoading;

  const performanceDateSelector =
    (history.location.pathname.includes('analytics/email-stats') ||
      history.location.pathname.includes('performanceq')) &&
    !history.location.pathname.includes('team-analytics') &&
    dateArray?.length ? (
      <CustomSelect
        items={dateArray}
        selectedItem={dateArray[2]}
        onChange={loadDataByChoosedPeriod}
        isPerformance
        disabled={isLoadingCheck}
      />
    ) : null;

  const performanceUserSection =
    (history.location.pathname.includes('analytics/email-stats') ||
      history.location.pathname.includes('performanceq')) &&
    !history.location.pathname.includes('team-analytics') ? (
      <>
        {performanceDateSelector}
        <div className="header__user-divider" />
        <span className="header__user-name">{user?.name || ''}</span>
        <Avatar
          user={user}
          image={user?.avatar}
          className="header__user-avatar"
          inHeader
        />
      </>
    ) : null;

  const teamQSelectors = history.location.pathname.includes(
    'team-analytics'
  ) ? (
    <TeamQDateAndTeamSelectors />
  ) : null;

  const isIframe = pathname.includes('personalq_competence');

  const defineHeaderClassName = () => {
    let className = 'header';

    if (isIframe) {
      className = 'hidden header';
    } else if (currentRoute?.label === 'My Engagements') {
      className = 'detailed-deals-page header';
    }

    return className;
  };

  const wrapperClassName = defineHeaderClassName();

  return (
    <header className={wrapperClassName}>
      <h1 className="header__title">{headerTitle()}</h1>
      <div className="header__user">
        {performanceUserSection}
        {teamQSelectors}
      </div>
    </header>
  );
};
